module.exports = __webpack_public_path__ + "static/media/Animal Control.cb3da8b0.jpg";